import { ModuleWithProviders, NgModule } from '@angular/core';
import { EINVOICE_ROUTE_PROVIDERS } from './providers/route.provider';

@NgModule()
export class einvoiceConfigModule {
  static forRoot(): ModuleWithProviders<einvoiceConfigModule> {
    return {
      ngModule: einvoiceConfigModule,
      providers: [EINVOICE_ROUTE_PROVIDERS],
    };
  }
}
